export class GetEventListBo {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderType: string = "asc";
    type: string = "string";
    field: string = "clientName";
    operator: string = "contains";
    value: string = "";
    orderColumn: string = "clientName";
    clientId: string | null;
    consultantId: string | null;
    startDate: string | null;
    endDate: string | null;
    matchCase: boolean = false;
    agencyID: string | null;
    locationID: string | null;
    serviceDeliveryPlanId : string | null;
    isedit : boolean =false;
}


export class SaveEventBo {
    id: string="00000000-0000-0000-0000-000000000000";
    clientId: string;
    clientName: string;
    consultantId: string;
    consultantName: string;
    startTime: string;
    endTime: string;
   
    eventTitle: string;
    eventDescription: string;
    statusLid: string | null;
    statusName: string;
    agencyId: string;
    agencyName: string;
    createdBy: string | null;
    createdIp: string;
    createdTime: string | null;
    modifiedBy: string | null;
    modifiedIp: string;
    modifiedTime: string | null;
    recordVersion: number;
    eventAlterList: EventAlertsBo[]

    cfssModel: string;
    typeofContactId: string | null;
    typeofServiceId: string | null;
    eventId: string;
    languageListIds: string[];
    languages: string;
    missingDocuments: string;
    serviceDeliveryPlanId : string | null;
    getConfirmation : boolean = false;
}

export class EventAlertsBo {
    eventId: string;
    eventAlertId: string;
    eventAlterName: string;
}